import template from './tableGridTextExtendedCell.html';
import controller from './tableGridTextExtendedCell.controller';
import _ from 'lodash';


let tableGridTextExtendedCellComponent = () => {
  return {
    restrict: 'E',
    replace: false,
    scope: {
      row: '=',
      columnName: '@',
      columns: '='
    },
    template,
    controller,
    controllerAs: 'vm',
    link: (scope, elem, attrs, ctrl) => {
      scope.column = _.find(scope.columns, {
        name: scope.columnName
      });

      scope.vm = scope;
      scope.vm.cellValue = ctrl.getExtendedValue(scope.row, scope.column.extendedConfig) || scope.row[scope.column.name];
      scope.vm.icon = ctrl.getIconStructure(scope.row, scope.column.extendedConfig);
      scope.vm.addClass = ctrl.getAdditionalClass(scope.row, scope.column.extendedConfig);
      
    }
  };
};
export default tableGridTextExtendedCellComponent;



// WEBPACK FOOTER //
// ./app/components/tableGridTextExtendedCell/tableGridTextExtendedCell.component.js